module.exports = __webpack_public_path__ + "img/59_21.c868385e.png";